// extracted by mini-css-extract-plugin
module.exports = {"button":"BackToTop_button__2BOad","button_show":"BackToTop_button_show__1RK2O","icon":"BackToTop_icon__1_R7E"};